import store from '@/store'

function errorHandler (err) {
  console.error(err)
  store.commit('api/setErrors', [err])
}

export function run (fn) {
  try {
    const r = fn()
    return (r instanceof Promise) ? r.catch(errorHandler) : r
  } catch (err) {
    errorHandler(err)
    return null
  }
}
